import type { NextPage } from "next";

// Automatic redirection is made to /[pageKey]
const Index: NextPage = () => {
  return <></>;
};

export default Index;
